module.exports = __webpack_public_path__ + "static/img/12.0f7c29a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/sp/12.png
// module id = u25Q
// module chunks = 0